/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import "./style.less";

class PipelineImgListScroll extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { moduleId, loop, autoplay, slidesPerView, spaceBetween } = this.props.config.baseConfig;
    new Swiper(moduleId ? `.swiper-container-${moduleId}` : '.swiper-container', {
      loop,
      autoplay: !autoplay ? false : {
        disableOnInteraction: false,
        delay: 2000,
      },
      slidesPerView: Number(slidesPerView),
      spaceBetween: Number(spaceBetween),
    });
  }

  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    if (!item.link) {
      // 空白不跳转
      return;
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      link: item.link,
      type: baseConfig.sortType,
      sort: index,
    };

    const convertUrl = utils.convertHref(item.link);
    utils.jumpToUrl(this.props.routeParams,convertUrl,item.link, options, -1,this.props,false);

  };

  render() {
    const { baseConfig, imgsList } = this.props.config;
    const { moduleId, marginTop, marginBottom, paddingLeft } = baseConfig;
    return (
      <div
        className="pipeline-imgListScroll"
        {...this.props['customAttributes']}
        style={{
          marginTop: marginTop + "px",
          marginBottom: marginBottom + "px",
        }}
      >
        <div className={moduleId ? `swiper-container swiper-container-${moduleId}` : 'swiper-container'} style={{paddingLeft: paddingLeft + "px"}}>
          <div className="swiper-wrapper">
            {
              imgsList.map((item, index) => {
                return (
                  <div className="swiper-slide" key={index} onClick={this.handleItemClick.bind(this, item, index)}>
                    <img src={utils.formatImgUrl(item.src, this.props.webpSupport)} alt="" />
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

PipelineImgListScroll.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImgListScroll };
export default PipelineImgListScroll;



// WEBPACK FOOTER //
// ./components/pipeline-imgListScroll/index.js